import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardHeader, CardBody, Collapse, Badge } from 'reactstrap';
import { Btn } from '../../../AbstractElements';
import { ChevronDown, ChevronRight, Save, Edit2 } from 'react-feather';

const SectionCard = ({
    title,
    subtitle,
    badge,
    badgeColor = 'light-primary',
    children,
    defaultOpen = false,
    editable = false,
    editing = false,
    onEditToggle,
    onSave,
    actions,
    headerRight,
    className = '',
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    // Auto-expand when editing starts
    useEffect(() => {
        if (editing) setIsOpen(true);
    }, [editing]);

    return (
        <Card className={className}>
            <CardHeader className='d-flex justify-content-between align-items-center py-3 section-card-header' style={{ cursor: 'pointer' }} onClick={() => setIsOpen(!isOpen)}>
                <div className='d-flex align-items-center gap-2'>
                    {isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                    <h5 className='mb-0'>{title}</h5>
                    {badge && <Badge color={badgeColor} className='ms-2'>{badge}</Badge>}
                    {subtitle && <span className='text-muted ms-2' style={{ fontSize: 'small', alignSelf: 'flex-end' }}>{subtitle}</span>}
                </div>
                <div className='d-flex align-items-center gap-2' onClick={(e) => e.stopPropagation()}>
                    {headerRight}
                    {editable && onEditToggle && (
                        <Btn attrBtn={{ className: `btn btn-sm ${editing ? 'btn-outline-info' : 'btn-outline-primary'}`, onClick: onEditToggle }}>
                            {editing ? 'Cancel' : <><Edit2 size={14} /> Edit</>}
                        </Btn>
                    )}
                    {editing && onSave && (
                        <Btn attrBtn={{ className: 'btn btn-sm btn-success', onClick: onSave }}>
                            <Save size={14} /> Save
                        </Btn>
                    )}
                    {actions}
                </div>
            </CardHeader>
            <Collapse isOpen={isOpen}>
                <CardBody>{children}</CardBody>
            </Collapse>
        </Card>
    );
};

export default SectionCard;
